import { buildDomainEvent } from '@galapagos/product-analytics';
import { trackProductEventWhenReady } from '@/app/analytics';
import type { RewardsCarouselItem } from '../rewards/carousel-items';
import { claimCarouselItemReported } from '../rewards/carousel-state';

export const REWARDS_CAROUSEL_ITEM_VIEWED = 'signup.rewards.carouselitem.viewed';

/**
 * Report a prize the first time it is on show in this page load, so a visit
 * sends at most one event per prize however long the card stays open.
 */
export function reportCarouselItemViewed(key: RewardsCarouselItem['key'], index: number): void {
  if (!claimCarouselItemReported(key)) return;
  void trackProductEventWhenReady(() =>
    buildDomainEvent(REWARDS_CAROUSEL_ITEM_VIEWED, { item_key: key, item_index: index }),
  );
}
